import React from 'react'
import Layout from './Layout'

const ProfilePage = () => {
    return <Layout />
}

export default ProfilePage